import { useEffect } from 'react';
import { jtlTileUrl } from '@/core/api/jtl-login.service';
import { Loader } from '@/components/Loader/Loader';

// Cognito's sign-out URL. Arrives here with Cognito's hosted session cleared; reopen the tile.
const JtlRelogin = () => {
  useEffect(() => {
    window.location.replace(jtlTileUrl());
  }, []);
  return <Loader />;
};

export default JtlRelogin;
